import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../shared/shared.module';
import { VisibleDateRangeComponent } from './visible-date-range/visible-date-range.component';



@NgModule({
  declarations: [VisibleDateRangeComponent],
  imports: [
    SharedModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
  ],
  exports : [
    VisibleDateRangeComponent
  ]
})
export class RlControlsModule { }
